// extracted by mini-css-extract-plugin
module.exports = {"Event":"Event_Event__ig29z"};